// This is a future filter example
export function currency (value, symbol = '¥') {
  let final = Math.round(value * 100) / 100
  final = final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return `${symbol} ${final}`
}
